import {
	Component,
	Input,
	OnInit
} from '@angular/core';
import {
	IParameterizedHtmlTextTemplateRefData,
	ParameterizedHtmlTextType,
	ParameterizedHtmlTextValueTypeEnum
} from '@shared/components/parameterized-html-text/parameterized-html-text.model';


@Component( {
	selector: 'app-parameterized-html-text[text][templateRefData]',
	templateUrl: './parameterized-html-text.component.html',
	styleUrls: [ './parameterized-html-text.component.scss' ]
} )
export class ParameterizedHtmlTextComponent implements OnInit {

	public parameterizedHtmlTextItems: ParameterizedHtmlTextType[];
	public readonly parameterizedHtmlTextValueTypeEnum = ParameterizedHtmlTextValueTypeEnum;

	@Input() paramMatcher: RegExp = new RegExp( /(\{\{.*\}\})/ );
	@Input() templateRefData: IParameterizedHtmlTextTemplateRefData;
	@Input() text: string;

	ngOnInit(): void {
		const parameterizedHtmlTextItems: ParameterizedHtmlTextType[] = [];
		const splitText: string[] = this.text.split( this.paramMatcher );

		splitText.forEach( ( splitItem: string ) => {
			if ( splitItem.length === 0 ) { return; }

			if ( splitItem.match( this.paramMatcher ) ) {
				const paramIdentifier: string = splitItem.replace( /\W/g, '' );
				if ( paramIdentifier in this.templateRefData ) {
					parameterizedHtmlTextItems.push( {
						valueType: ParameterizedHtmlTextValueTypeEnum.TEMPLATE_REF,
						value: this.templateRefData[ paramIdentifier ]
					} );
				}
			} else {
				parameterizedHtmlTextItems.push( {
					valueType: ParameterizedHtmlTextValueTypeEnum.STRING,
					value: splitItem
				} );
			}
		} );

		this.parameterizedHtmlTextItems = parameterizedHtmlTextItems;
	}
}
